// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__wef8R","skill__list":"Skills_skill__list__I0keE"};